import { colors } from '@mui/material';

const buildGradient = (start, end) =>
  `linear-gradient(180deg, ${start} 0%, ${end} 100%)`;

const palette = {
  primary: {
    contrastText: colors.common.white,
    dark: colors.indigo[900],
    main: colors.indigo[500],
    light: colors.indigo[100]
  },
  secondary: {
    contrastText: colors.common.white,
    dark: colors.blue[900],
    main: colors.blue['A400'],
    light: colors.blue['A400']
  },
  error: {
    contrastText: colors.common.white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400]
  },
  success: {
    contrastText: colors.common.white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400]
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600]
  },
  link: colors.blue[800],
  icon: colors.blueGrey[600],
  background: {
    default: '#F4F6F8',
    paper: colors.common.white
  },
  divider: colors.grey[200],
  business: {
    statusRunning: '#67bf0e',
    statusActive: '#4c75d7',
    statusInactive: '#a5a8a2',
    statusWarning: '#df000f',
    scheduleMain: colors.blueGrey[500],
    scheduleOverflowSameDay: colors.teal[600],
    scheduleOverflowNextDay: colors.grey[600],
  },
  app: {
    labelDefault: colors.grey[600],
    metricBackground: '#f0f0f0',
    popupBorder: colors.common.black,
    schedulePastBackground: '#c4bfbfbf',
    scheduleSelectedBackground: '#add8e6',
    scheduleValueBackground: colors.grey[200],
    tooltipBackground: '#f5f5f9',
    tooltipBorder: '#dadde9',
  },
  gradients: {
    grey: buildGradient(colors.grey[400], colors.grey[600]),
    blue: buildGradient(colors.blue[700], colors.blue[900]),
    indigo: buildGradient(colors.indigo[400], colors.indigo[600]),
    green: buildGradient(colors.green[400], colors.green[600]),
    orange: buildGradient(colors.orange[400], colors.orange[700]),
    red: buildGradient(colors.red[500], colors.red[700]),
  },
};

export default palette;
